export const CommercialServiceList = [
    {
        title:'Restaurants & Cafes',
        desc:'Pest issues in food service environments can quickly escalate into health risks, damaged reputations, and regulatory trouble. We provide targeted pest control for kitchens, dining areas, and food storage zones—ensuring a clean, compliant, and hygienic space where both staff and customers feel safe.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_01.webp",
        link: "/customer/consult/restaurants",
    },
    {
        title:'Hotels & Resorts',
        desc:'Hospitality businesses require the highest standards of cleanliness. Our pest control services target areas like guest rooms, kitchens, laundry rooms, and storage areas to protect your guests and maintain your reputation. We offer customized AMC (Annual Maintenance Contract) pest control plans.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_02.webp",
        link: "/customer/consult/hotels",
    },
    {
        title:'Offices & Corporate Spaces',
        desc:'Pests in office spaces can create an uncomfortable environment for employees and affect productivity. We eliminate pests in pantries, bathrooms, workspaces, and storage areas to maintain a professional and comfortable workspace.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_03.webp",
        link: "/customer/consult/offices",
    },
    {
        title:'Retail Stores & Malls',
        desc:'Pests in retail spaces can damage products and affect customer experience. We provide customized solutions for shops, supermarkets, and malls to ensure a clean and pest-free shopping experience.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_04.webp",
        link: "/customer/consult/malls",
    },
    {
        title:'Warehouses & Industrial Facilities',
        desc:'Pests in warehouses, factories and plants can damage goods and create safety hazards. Our team focuses on storage areas, loading docks, and production lines to eliminate pests and protect inventory.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_05.webp",
        link: "/customer/consult/warehouses",
    },
    {
        title:'Schools & Educational Institutions',
        desc:'A pest-free learning environment is essential for students and staff. We target classrooms, cafeterias, and restrooms to create a safe and hygienic space for education.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_06.webp",
        link: "/customer/consult/schools",
    },
    {
        title:'Hospital & Clinics',
        desc:'Pest issues in food service environments can quickly escalate into health risks, damaged reputations, and regulatory trouble. We provide targeted pest control for kitchens, dining areas, and food storage zones—ensuring a clean, compliant, and hygienic space where both staff and customers feel safe.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_07.webp",
        link: "/customer/consult/hospital",
    },
    {
        title:'Construction Site & Buildings',
        desc:'We provide pre-construction and post-construction pest control to protect sites from termites, rodents, and other structural pests. Our treatments ensure long-term protection and help keep your building project safe, compliant, and pest-free from start to finish.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_08.webp",
        link: "/customer/consult/buildings",
    },
    {
        title:'Government Premises',
        desc:'Government Premises need secure, clean, and pest-free environments to operate efficiently. UST Pest Services provides reliable pest control solutions for government offices, administrative buildings, and public facilities, ensuring hygiene, safety, and uninterrupted public service.',
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_09.webp",
        link: "/customer/consult/government",
    },
]

export const ResidentialServiceList = [
    {
        title: "Apartments & Flats",
        desc: "Pests like cockroaches, ants, and rodents can easily enter apartments through shared walls and ventilation systems. We inspect and treat areas like kitchens, bathrooms, balconies, and storage spaces to ensure comprehensive protection.",
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_10.webp",
        link: "/customer/consult/apartments",
    },
    {
        title: "Independent Houses, Villas & Farmhouses",
        desc: "Larger living spaces can attract a range of pests, from termites and rodents to mosquitoes and ants. Our team conducts a thorough inspection and applies targeted treatments to protect both the indoor and outdoor areas of your home.",
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_11.webp",
        link: "/customer/consult/houses",
    },
    {
        title: "Gated Communities & Societies",
        desc: "Pests often find their way into gated communities through common areas, gardens, basements, and water pipelines. Our expert team conducts thorough inspections of clubhouses, corridors, parking areas, and individual units to identify infestation hotspots.",
        image: "https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_12.webp",
        link: "/customer/consult/societies",
    },
]

export const getServiceData = (serviceType) => {

    // Search in both Commercial and Residential lists
    const allServices = [...CommercialServiceList, ...ResidentialServiceList]

    const service = allServices.find((item) => {
        // Extract the service type from the link path (e.g., "/contact/restaurants" -> "restaurants")
        const linkType = item.link.split("/").pop()
        return linkType === serviceType
    })

    const result = service || CommercialServiceList[0]
    return result
}